import { Button, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";

export const IconButton = styled(Button)(() => {
  return {
    borderRadius: "4px",
    color: ediphiPalette.textStrong,
    border: `1px solid ${ediphiPalette.borderStrong}`,
    height: "24px",
    width: "24px",
    minHeight: "24px",
    minWidth: "24px",
    paddingLeft: "4px",
    paddingRight: "4px",
    paddingTop: "0px",
    paddingBottom: "0px",
    // background: ediphiPalette.surfaceSubtle,
    background: ediphiPalette.surface,
    "&:hover": {
      color: ediphiPalette.brand800,
      border: `1px solid ${ediphiPalette.brand800}`,
    },
    // Not hoistable to the theme: it has to outrank the `&:hover` rule directly above, which it does
    // on source order at equal specificity. It therefore has to restate *every* property that rule
    // touches — the border included, or a disabled button still takes the hover outline.
    "&.Mui-disabled": {
      backgroundColor: ediphiPalette.surfaceDisabled,
      color: ediphiPalette.textDisabled,
      border: `1px solid ${ediphiPalette.borderColor}`,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
    },
  };
});
